import React, { FC } from 'react'
import styled from 'styled-components'
import SearchIcon from '../icons/SearchIcon'

interface SearchInputProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  value?: string
  placeholder?: string
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void
  onFocus?: (event: React.FocusEvent<HTMLInputElement, Element>) => void
  onValidate?: () => void
}

const SearchInput: FC<SearchInputProps> = (props) => {
  const { onValidate, ...rest } = props

  const onEnterPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (['Enter', 'NumpadEnter'].includes(e.code)) {
      onValidate && onValidate()
    }
  }

  const onSearchIconClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation()
    onValidate && onValidate()
  }

  return (
    <InputWrapper>
      <Input type="text" {...rest} onKeyPress={onEnterPress} />
      <SearchIconWrapper type="button" onClick={onSearchIconClick}>
        <SearchIcon size={18} />
      </SearchIconWrapper>
    </InputWrapper>
  )
}

const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  gap: 12px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  align-content: stretch;
`

const Input = styled.input`
  flex-grow: 1;
  font-style: normal;
  font-weight: ${({ theme }) => theme.weight.normal};
  font-size: ${({ theme }) => theme.size.small};
  line-height: 8px;

  &::placeholder {
    font-weight: ${({ theme }) => theme.weight.normal};
    font-size: ${({ theme }) => theme.size.small};
    font: ${({ theme }) => theme.font.default};
  }
`

const SearchIconWrapper = styled.button`
  background-color: transparent;
  width: fit-content;
  height: fit-content;
`

export default SearchInput
